import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Col, Card, Button, CardSubtitle } from "react-bootstrap";
import { useAuth } from "../../contexts/AuthContext";
import "./index.css";
import assured from "../../assets/assuredflipcart.jpg";

const ProductCard = ({ item, handler, style = "" }) => {
  const navigate = useNavigate();
  const containerRef = useRef(null);
  const {
    whiteListProducts,
    handleSetWhiteListProducts,
    setSingleProduct,
    setSelectcategory,
    isMobile,
  } = useAuth();
  const [imageWidth, setImageWidth] = useState(null);
  const [imageHeight, setImageHeight] = useState(null);
  const [randomRatingCount, setRandomRatingCount] = useState(0);

  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      setImageWidth(img.width);
      setImageHeight(img.height);
    };
    img.src = item?.images[0]?.src ?? "";
  }, [item?.images[0]?.src]);

  const handleRedirect = (id) => {
    navigate(`/single-product/${id}`, {
      state: {
        handle: handler,
      },
    });
    setSelectcategory(handler);
  };

  const imageStyle = {
    width: "100%",
  };

  useEffect(() => {
    const generateRandomRating = () => {
      const min = 100;
      const max = 5000;
      return Math.floor(Math.random() * (max - min + 1)) + min;
    };

    setRandomRatingCount(generateRandomRating());
  }, []);

  if (imageWidth && imageHeight) {
    const aspectRatio = imageWidth / imageHeight;
    let splitValue = aspectRatio.toString().split(".");
    if (splitValue && splitValue.length > 0) {
      if (splitValue.length > 1) {
        splitValue = `${splitValue[0]}.${splitValue[1].charAt(0)}`;
      } else {
        splitValue = splitValue[0];
      }
    }
    splitValue = +splitValue;

    if (splitValue > 1) {
      // Landscape image
      imageStyle.height = "auto"; // Maintain aspect ratio
    } else {
      // Portrait or square image
      if (splitValue <= 1 && splitValue >= 0.8 && window.innerWidth < 455) {
        imageStyle.height = "auto";
        imageStyle.width = "100%";
      } else {
        imageStyle.height = "100%";
        imageStyle.width = "auto";
      }
    }
  }

  function calculateDiscount(compareAtPrice, price) {
    // Convert string values to numbers
    const actualPrice = parseFloat(price);
    let mrp =
      compareAtPrice && parseFloat(compareAtPrice) > 0
        ? parseFloat(compareAtPrice)
        : actualPrice * 3;

    // Ensure MRP is greater than 0 to avoid division errors
    if (mrp <= 0) {
      console.error("Invalid MRP or price values");
      return 0;
    }

    // Calculate discount percentage
    const discountPercentage = ((mrp - actualPrice) / mrp) * 100;
    return discountPercentage.toFixed(2); // Round to 2 decimal places
  }

  // Example Usage
  const compareAtPrice = "300"; // MRP (string or null)
  const price = "200"; // Selling price (string)

  const discount = calculateDiscount(compareAtPrice, price);
  return (
    <>
      {isMobile ? (
        <Col
          key={item?.id}
          style={{ ...style, maxHeight: "370px", padding: "0px " }}
        >
          <Card
            style={{ height: "100%", borderRadius: 2 }}
            onClick={() => {
              setSingleProduct(item);
              // handleRedirect(item._id);
              handleRedirect(item?.handle);
            }}
          >
            <div
              className="position-relative"
              style={{
                height: "calc(100% - 100px)",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              ref={containerRef}
            >
              <Card.Img
                variant="top"
                src={item?.images[0]?.src ?? ""}
                style={imageStyle}
              />
            </div>
            <Card.Body className="p-2 pb-0">
              <div className="d-flex  justify-content-between align-items-center">
                <Card.Subtitle
                  style={{
                    textAlign: "left",
                    color: "#262626",
                    fontWeight: "500",
                    fontSize: "14px",
                  }}
                  className="mb-0 text-ellips"
                >
                  {item?.title}
                </Card.Subtitle>
                <div
                  className="ms-2"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSetWhiteListProducts(item);
                  }}
                >
                  {whiteListProducts?.find((o) => o?.id === item?.id) ? (
                    <svg width="20" height="20" viewBox="0 0 24 24">
                      <g
                        stroke="none"
                        strokeWidth="1"
                        fill="none"
                        fillRule="evenodd"
                      >
                        <g
                          fill="#ed143d"
                          transform="translate(1.000000, 2.000000)"
                        >
                          <path d="M11.02835,19.276575 L10.972,19.276575 C10.6304,19.276575 10.2965,19.137625 10.05605,18.895075 L2.71865,11.513925 C1.53495,10.323225 0.88325,8.735275 0.88325,7.042675 C0.88325,5.350075 1.53495,3.762475 2.71865,2.571775 C3.9034,1.379675 5.48435,0.723425 7.1703,0.723425 C8.5759,0.723425 9.90905,1.179825 11,2.022625 C12.0913,1.179825 13.4241,0.723425 14.8297,0.723425 C16.516,0.723425 18.09695,1.379675 19.2817,2.572125 C20.46505,3.762475 21.11675,5.350075 21.11675,7.042675 C21.11675,8.735625 20.46505,10.323225 19.2817,11.513925 L11.94325,18.895775 C11.6993,19.141475 11.3745,19.276575 11.02835,19.276575 L11.02835,19.276575 Z"></path>
                        </g>
                      </g>
                    </svg>
                  ) : (
                    <svg width="20" height="20" viewBox="0 0 24 24">
                      <g
                        stroke="none"
                        strokeWidth="1"
                        fill="none"
                        fillRule="evenodd"
                      >
                        <g fill="#3E4152">
                          <path d="M8.1703,4.473425 C6.9537,4.473425 5.8134,4.946625 4.95975,5.805525 C4.10435,6.666175 3.63325,7.815575 3.63325,9.042675 C3.63325,10.269775 4.10435,11.419525 4.95975,12.280175 L12,19.362425 L19.0406,12.279825 C19.89565,11.419525 20.36675,10.270125 20.36675,9.042675 C20.36675,7.815575 19.89565,6.665825 19.0406,5.805875 C19.0406,5.805875 19.0406,5.805525 19.04025,5.805525 C18.1866,4.946625 17.0463,4.473425 15.8297,4.473425 C14.6138,4.473425 13.4742,4.946275 12.62055,5.804475 C12.29225,6.134525 11.70845,6.134875 11.3798,5.804475 C10.5258,4.946275 9.3862,4.473425 8.1703,4.473425 L8.1703,4.473425 Z M12.02835,21.276575 L11.972,21.276575 C11.6304,21.276575 11.2965,21.137625 11.05605,20.895075 L3.71865,13.513925 C2.53495,12.323225 1.88325,10.735275 1.88325,9.042675 C1.88325,7.350075 2.53495,5.762475 3.71865,4.571775 C4.9034,3.379675 6.48435,2.723425 8.1703,2.723425 C9.5759,2.723425 10.90905,3.179825 12,4.022625 C13.0913,3.179825 14.4241,2.723425 15.8297,2.723425 C17.516,2.723425 19.09695,3.379675 20.2817,4.572125 C21.46505,5.762475 22.11675,7.350075 22.11675,9.042675 C22.11675,10.735625 21.46505,12.323225 20.2817,13.513925 L12.94325,20.895775 C12.6993,21.141475 12.3745,21.276575 12.02835,21.276575 L12.02835,21.276575 Z"></path>
                        </g>
                      </g>
                    </svg>
                  )}
                </div>
              </div>
              <Card.Text className="mb-0" style={{ lineHeight: "18px" }}>
                {/* <span
                style={{
                  color: "#388e3c",
                  fontSize: "14px",
                  fontWeight: "500",
                  marginTop: "2px",
                }}
              >{`${(
                ((item?.price - item.discount) / item?.price) *
                100
              ).toFixed(0)}% OFF`}</span> */}
                <span
                  style={{
                    color: "#388e3c",
                    fontSize: "14px",
                    fontWeight: "500",
                    marginTop: "2px",
                  }}
                >
                  {/* {`${(
                ((parseInt(item?.variants?.[0]?.compare_at_price?parseInt(item?.variants?.[0]?.compare_at_price):parseInt(item?.variants?.[0]?.price)) - parseInt(item?.variants?.[0]?.price)) /
                parseInt(item?.variants?.[0]?.compare_at_price?item?.variants?.[0]?.compare_at_price:parseInt(item?.variants?.[0]?.price))) *
                100
              
              ).toFixed(0)}% OFF`} */}

                  {/* {`${calculateDiscount(
                  item?.variants?.[0]?.compare_at_price,
                  item?.variants?.[0]?.price
                )} 
                 % OFF`} */}
                </span>
                {/* <span
                style={{
                  fontSize: "12px",
                  color: "#9A9A9A",
                  marginLeft: "5px",
                  textDecoration: "line-through",
                }}
              >
                ₹
                {item?.variants?.[0]?.compare_at_price &&
                parseInt(item?.variants?.[0]?.compare_at_price) > 0
                  ? item?.variants?.[0]?.compare_at_price
                  : item?.variants?.[0]?.price * 3}
              </span> */}
              </Card.Text>
              <Card.Text
                style={{
                  textAlign: "left",
                  fontSize: "16px",
                  fontWeight: "bold",
                  color: "#000",
                }}
                className="mb-0"
              >
                <span>
                  <span style={{ fontSize: "11px" }}>₹</span>{" "}
                  {item?.variants?.[0]?.price}
                </span>
                {process.env.REACT_APP_FLIPASSURED_IMAGE === "yes" ? (
                  <img
                    src={assured}
                    width="60"
                    style={{ marginLeft: "10px" }}
                  />
                ) : (
                  ""
                )}
              </Card.Text>
              {/* <Card.Text className="mb-0 ">
              <span className="rating_box_des">
                {(Math.random() * (5 - 4) + 4).toFixed(1)}
                <i className="fa-solid fa-star" color="red"></i>
              </span>
              <span className="rating_num">{randomRatingCount} Ratings</span>
            </Card.Text> */}
              {/* <Card.Text>
              <div className="delivery-txt">Limited time deal</div>
            </Card.Text> */}
            </Card.Body>
            <Card.Footer className="px-2 py-0 bg-white border-0 pt-0 pb-1">
              <Button
                className="w-100"
                variant="dark"
                style={{
                  backgroundColor: process.env.REACT_APP_THEAM_COLOR,
                  border: "none",
                }}
              >
                Add To Cart
              </Button>
            </Card.Footer>
            {/* <Card.Text className="mt-0">
            <div className="free-delivery-txt">Free Delivery in Two Days</div>
          </Card.Text> */}
          </Card>
        </Col>
      ) : (
        <Col
          key={item?.id}
          style={{
            ...style,
            maxHeight: "440px",
            padding: "0px ",
            marginBottom: "20px",
          }}
        >
          {" "}
          <Card
            style={{
              height: "100%",
              overflow: "hidden",
              cursor: "pointer",
              position: "relative",
              border: "none",
              width: "95%",
            }}
            onClick={() => {
              setSingleProduct(item);
              handleRedirect(item?.handle);
            }}
          >
            <div
              className="position-relative"
              style={{
                height: "calc(100% - 100px)",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
              }}
              ref={containerRef}
            >
              {/* Wishlist button top-right */}
              <div
                className="position-absolute  d-flex align-items-center justify-content-center"
                style={{
                  top: "-7px",
                  right: "-6px",
                  zIndex: 5,
                  cursor: "pointer",
                  background: "#fff",
                  width: "45px",
                  height: "45px",
                  textAlign: "center",
                  borderRadius: "50%",
                  boxShadow: "0px 2px 6px rgba(0,0,0,0.15)",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleSetWhiteListProducts(item);
                }}
              >
                {whiteListProducts?.find((o) => o?.id === item?.id) ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="28"
                    viewBox="0 0 30 28"
                    fill="none"
                  >
                    <path
                      d="M22.044 0.5C18.978 0.5 16.3305 2.2955 15 4.9145C13.6695 2.2955 11.022 0.5 7.956 0.5C3.561 0.5 0 4.1855 0 8.7215C0 13.2575 2.7255 17.4155 6.2475 20.831C9.7695 24.2465 15 27.5 15 27.5C15 27.5 20.061 24.3005 23.7525 20.831C27.69 17.132 30 13.271 30 8.7215C30 4.172 26.439 0.5 22.044 0.5Z"
                      fill="#960707"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="28"
                    viewBox="0 0 33 28"
                    fill="none"
                  >
                    <path
                      d="M16.5001 5.02084L15.7126 5.77917C15.8146 5.88502 15.9369 5.96922 16.0722 6.02673C16.2075 6.08424 16.3531 6.11388 16.5001 6.11388C16.6471 6.11388 16.7926 6.08424 16.9279 6.02673C17.0632 5.96922 17.1856 5.88502 17.2876 5.77917L16.5001 5.02084ZM9.20987 20.9458C8.98554 20.7613 8.69711 20.6735 8.40803 20.7017C8.11896 20.7299 7.85291 20.8717 7.66841 21.096C7.48392 21.3204 7.3961 21.6088 7.42427 21.8979C7.45244 22.187 7.59429 22.453 7.81862 22.6375L9.20987 20.9458ZM2.4155 16.5577C2.48444 16.6837 2.57753 16.7949 2.68945 16.885C2.80137 16.975 2.92993 17.0421 3.06778 17.0825C3.20564 17.1228 3.3501 17.1356 3.4929 17.1202C3.63571 17.1047 3.77407 17.0612 3.90008 16.9923C4.0261 16.9233 4.1373 16.8303 4.22733 16.7183C4.31737 16.6064 4.38449 16.4779 4.42484 16.34C4.4652 16.2022 4.478 16.0577 4.46253 15.9149C4.44706 15.7721 4.40361 15.6337 4.33466 15.5077L2.4155 16.5577ZM3.0105 10.3248C3.0105 7.18938 4.78237 4.55854 7.20175 3.45167C9.55258 2.37688 12.7113 2.66125 15.7126 5.77917L17.2876 4.26396C13.7292 0.564169 9.59341 -0.0468723 6.29175 1.4625C3.063 2.93979 0.822998 6.36979 0.822998 10.3248H3.0105ZM11.3915 25.4375C12.1397 26.0267 12.9417 26.6538 13.754 27.1292C14.5663 27.6046 15.4938 27.9896 16.5001 27.9896V25.8021C16.048 25.8021 15.5172 25.6271 14.858 25.2406C14.1974 24.8556 13.5134 24.3248 12.7463 23.7196L11.3915 25.4375ZM21.6086 25.4375C23.6882 23.7969 26.3482 21.9185 28.4336 19.5692C30.5584 17.1775 32.1772 14.2127 32.1772 10.3248H29.9897C29.9897 13.5302 28.6772 15.9992 26.7988 18.1167C24.8811 20.275 22.4647 21.9769 20.2538 23.7196L21.6086 25.4375ZM32.1772 10.3248C32.1772 6.36979 29.9386 2.93979 26.7084 1.4625C23.4067 -0.0468723 19.2738 0.564169 15.7126 4.2625L17.2876 5.77917C20.2888 2.66271 23.4476 2.37688 25.7984 3.45167C28.2178 4.55854 29.9897 7.18792 29.9897 10.3248H32.1772ZM20.2538 23.7196C19.4867 24.3248 18.8028 24.8556 18.1422 25.2406C17.4815 25.6256 16.9522 25.8021 16.5001 25.8021V27.9896C17.5063 27.9896 18.4338 27.6031 19.2461 27.1292C20.0599 26.6538 20.8605 26.0267 21.6086 25.4375L20.2538 23.7196ZM12.7463 23.7196C11.5855 22.8052 10.4057 21.9302 9.20987 20.9458L7.81862 22.6375C9.02904 23.6335 10.3095 24.5844 11.3915 25.4375L12.7463 23.7196ZM4.33466 15.5092C3.45605 13.9232 3.00006 12.1379 3.0105 10.3248H0.822998C0.822998 12.7135 1.4355 14.7654 2.4155 16.5577L4.33466 15.5092Z"
                      fill="#4B2B03"
                    />
                  </svg>
                )}
              </div>

              {/* Product image */}
              <Card.Img
                variant="top"
                src={item?.images[0]?.src ?? ""}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "30px 10px 30px 6px",
                }}
              />

              <div
                style={{
                  position: "absolute",
                  bottom: "-15px",
                  width: "140px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  backgroundColor: process.env.REACT_APP_THEAM_COLOR,
                  padding: "5px 15px",
                  borderRadius: "30px 5px 30px 5px",
                  boxShadow: "0px 2px 6px rgba(0,0,0,0.15)",
                  fontWeight: "bold",
                  fontSize: "14px",
                  color: "white",
                }}
              >
                ₹ {item?.variants?.[0]?.price}
              </div>
            </div>

            <Card.Body className="p-2 pb-0 mt-3">
              <Card.Subtitle
                style={{
                  textAlign: "center",
                  color: "#262626",
                  fontWeight: "700",
                  fontSize: "16px",
                }}
                className="mb-1 text-ellips"
              >
                {item?.title}
              </Card.Subtitle>
            </Card.Body>

            <Card.Footer className="px-2 py-0 bg-white border-0 pt-0 pb-2">
              <Button
                className="w-100"
                variant="dark"
                style={{
                  backgroundColor: process.env.REACT_APP_THEAM_COLOR,
                  border: "none",
                  borderRadius: "31px 5px 31px 5px",
                }}
              >
                Add To Cart
              </Button>
            </Card.Footer>
          </Card>
        </Col>
      )}
    </>
  );
};

export default ProductCard;
